export default __webpack_public_path__ + "static/media/VChurchilClosed.6dddadf9.jpg";